import React, { PureComponent } from 'react';
import { Icon, Switch, Popover } from 'antd';
import { DndProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import { isEqual } from 'lodash';

import { IReportViewProps, IReportQueryViewProps } from '@duoke/tools/umd/report';
import ViewItem from './ViewItem';
import styles from './index.less';

const defaultProps = {
  defaultValue: [],
  dataSource: {}, // 表格筛选配置项
};
const initialState = {
  values: [] as IReportQueryViewProps[],
};
interface IProps {
  disableConfig: string[];
  dataSource: Record<string, IReportViewProps>;
  defaultValue: IReportQueryViewProps[];
  onChange: (val: IReportQueryViewProps[]) => void;
}
type State = Readonly<typeof initialState>;

export default class View extends PureComponent<IProps, State> {
  static defaultProps = defaultProps;
  readonly state = initialState;

  componentDidMount() {
    const { defaultValue } = this.props;

    this.setState({
      values: [...defaultValue],
    });
  }

  componentDidUpdate(prevProps: IProps) {
    const { defaultValue } = this.props;

    if (!isEqual(prevProps.defaultValue, defaultValue)) {
      this.setState({ values: [...defaultValue] });
    }
  }

  render() {
    const { disableConfig, dataSource } = this.props;
    const { values } = this.state;

    const val = values.filter((v) => v.isSelected).map((v) => v.fieldKey);

    return (
      <div className={styles.view}>
        <DndProvider backend={HTML5Backend}>
          {values.map(
            (v, i) =>
              v &&
              v.fieldKey &&
              !!v.isSelected &&
              dataSource[v.fieldKey] &&
              !disableConfig.includes(v.fieldKey) && (
                <ViewItem
                  index={i}
                  value={v}
                  key={v.fieldKey}
                  moveView={this.handleMove}
                  source={dataSource[v.fieldKey]}
                  onChange={this.handleChange(i)}
                  onClose={this.handleViewToggle(v.fieldKey)}
                  disabled={
                    !Number(dataSource[v.fieldKey].isEditable || 0) ||
                    disableConfig.includes(v.fieldKey) ||
                    values.length < 3
                  }
                />
              )
          )}
        </DndProvider>
        <hr className={styles.separator} />
        <div>
          {Object.values(dataSource).map(
            (v) =>
              v &&
              v.value &&
              !disableConfig.includes(v.value) &&
              ![...val, 'id'].includes(v.value) && (
                <div key={v.value} className={styles['view-item']}>
                  <div style={{ color: '#AFAFAF' }}>
                    <Popover content={v.description || '暂无描述'}>
                      <Icon type="question-circle" className={styles['view-desc']} />
                    </Popover>
                    <span className={styles['text-ellipse']}>{v.name}</span>
                  </div>
                  <div>
                    <Switch
                      size="small"
                      onChange={this.handleViewToggle(v.value)}
                      disabled={disableConfig.includes(v.value)}
                    />
                  </div>
                </div>
              )
          )}
        </div>
      </div>
    );
  }
  handleMove = (dIndex: number, hIndex: number) => {
    const { onChange } = this.props;
    const { values } = this.state;

    const item = values.splice(dIndex, 1)[0];
    values.splice(hIndex, 0, item);
    this.setState({ values: [...values] }, () => onChange && onChange([...values]));
  };
  // 当钉住时，钉在首位上移至钉住首位，钉在末尾下移至钉住末尾；
  // 当取消钉住时，原钉在首位的元素下移至未钉住首位，原钉在末尾的元素上移至未钉住末尾
  // => left，钉在首位；right，钉在末尾
  handleChange = (i: number) => {
    return (v: IReportQueryViewProps) => {
      const { onChange } = this.props;
      const { values } = this.state;

      // const fixed = v.fixed || values[i].fixed;
      const now = values.splice(i, 1);
      if (v.fixed) {
        values.splice(v.fixed === 'right' ? values.length : 0, 0, v);
      } else {
        const index = values.findIndex(
          (v) => (now[0].fixed === 'left' && !v.fixed) || v.fixed === 'right'
        );
        values.splice(index < 0 ? values.length : index, 0, v);
      }

      this.setState({ values: [...values] }, () => onChange && onChange([...values]));
    };
  };
  // 当视图开启时，加入到未钉住视图首位。当视图关闭时删除其所有属性
  handleViewToggle = (key: string) => {
    return (checked: boolean) => {
      const { onChange } = this.props;
      const { values } = this.state;

      const val: IReportQueryViewProps[] = values.map((v) =>
        v.fieldKey === key ? { ...v, isSelected: checked ? 1 : 0, fixed: '' } : v
      );
      this.setState({ values: val }, () => onChange && onChange(val));
    };
  };
}
